(() => {
  function mount(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-icl-data]').textContent);
    const form = root.querySelector('[data-icl-form]');
    const groups = [...root.querySelectorAll('[data-icl-option-group]')];
    const year = root.querySelector('[data-icl-year]');
    const trans = root.querySelector('[data-icl-transmission]');
    const configuration = root.querySelector('[data-icl-configuration]');
    const suspension = root.querySelector('[data-icl-suspension]');
    const switchWrap = root.querySelector('[data-icl-switch-wrap]');
    const switchSelect = root.querySelector('[data-icl-switch]');
    const extras = root.querySelector('[data-icl-extras]');
    const button = root.querySelector('[data-icl-submit]');
    const error = root.querySelector('[data-icl-error]');
    const fitmentNote = root.querySelector('[data-icl-fitment]');
    const vin = root.querySelector('[data-icl-vin]');
    const pending = root.dataset.pending === 'true';
    const variants = Array.isArray(data.variants) ? data.variants : [];
    const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency || 'USD'}).format(cents / 100);
    let chosen = null;
    let busy = false;
    let wasSotf = false;
    function supportValue() { return root.querySelector('[data-icl-support]:checked')?.value; }
    function update() {
      const yearIndex = (data.options || []).findIndex(name => /year/i.test(name));
      const yearGroup = groups.find(group => Number(group.dataset.index) === yearIndex);
      if (year.value && yearGroup) {
        const value = Number(year.value) <= 2018 ? '2013–2018' : '2019–2021';
        yearGroup.querySelectorAll('input').forEach(input => { input.checked = input.value === value; });
      }
      const manual = [...trans.options].find(option => option.value === 'G56');
      if (manual) {
        manual.disabled = Number(year.value) >= 2019;
        if (manual.disabled && trans.value === 'G56') trans.value = '';
      }
      chosen = variants.find(variant => groups.every(group => group.querySelector('input:checked')?.value === variant.options[Number(group.dataset.index)]));
      const calibration = chosen?.options.find(value => /SOTF|Single/i.test(value)) || root.querySelector('[data-icl-calibration]:checked')?.value || '';
      const sotf = /SOTF/i.test(calibration);
      switchWrap.hidden = !sotf;
      switchSelect.required = sotf;
      switchSelect.disabled = !sotf;
      if (sotf && !wasSotf && !switchSelect.value) extras.open = true;
      wasSotf = sotf;
      let issue = '';
      const transReview = trans.value === 'Other or swapped' || trans.value === 'G56';
      if (configuration.value === 'Cab and chassis' || transReview) issue = data.messages.fitment;
      if (suspension && (suspension.value === 'Other or unknown' || suspension.value === 'Factory rear air')) issue = data.messages.suspension;
      configuration.setCustomValidity(configuration.value === 'Cab and chassis' ? data.messages.fitment : '');
      trans.setCustomValidity(transReview ? data.messages.fitment : '');
      if (suspension) suspension.setCustomValidity(issue === data.messages.suspension ? issue : '');
      fitmentNote.hidden = !issue;
      fitmentNote.textContent = issue;
      const extraSwitch = sotf && switchSelect.value === String(data.switch.id) ? data.switch.price : 0;
      const extraSupport = supportValue() === String(data.support.id) ? data.support.price : 0;
      const total = (chosen?.price || 0) + extraSwitch + extraSupport;
      root.querySelector('[data-icl-total]').textContent = pending ? data.messages.pending : chosen ? format(total) : data.messages.unavailable;
      root.querySelector('[data-icl-variant]').value = chosen?.id || '';
      button.disabled = pending || busy || !chosen?.available || Boolean(issue);
      if (!pending) button.textContent = busy ? data.messages.adding : (chosen?.available ? data.messages.add : data.messages.unavailable);
    }
    const initialId = new URL(window.location.href).searchParams.get('variant');
    const initial = variants.find(variant => String(variant.id) === initialId) || variants.find(variant => String(variant.id) === root.querySelector('[data-icl-variant]').value) || variants[0];
    if (initial) groups.forEach(group => group.querySelectorAll('input').forEach(input => { input.checked = input.value === initial.options[Number(group.dataset.index)]; }));
    form.addEventListener('change', update);
    form.addEventListener('invalid', event => { if (extras.contains(event.target)) extras.open = true; }, true);
    vin.addEventListener('input', () => { vin.value = vin.value.toUpperCase().replace(/\s/g,''); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || pending) return;
      update();
      if (button.disabled || !form.reportValidity() || !chosen) return;
      const properties = {};
      for (const [key,value] of new FormData(form)) if (key.startsWith('properties[') && value) properties[key.slice(11,-1)] = value;
      properties['Calibration provider'] = 'Ironline Diesel';
      properties['File access'] = supportValue() ? (supportValue() === 'included' ? '4 Weeks' : 'Full Support') : chosen.options[(data.options || []).findIndex(name => /access|support/i.test(name))];
      properties['SOTF switch'] = switchWrap.hidden ? 'Not required' : (switchSelect.value === 'owned' ? 'Already owned' : 'Add physical switch');
      if (!vin.value) properties['VIN confirmation'] = 'Required before fulfillment';
      const items = [{id:chosen.id,quantity:1,properties}];
      const addonProperties = {'Parent package':chosen.sku || String(chosen.id)};
      if (vin.value) addonProperties['For Cummins VIN'] = vin.value;
      if (supportValue() === String(data.support.id)) items.push({id:data.support.id,quantity:1,properties:addonProperties});
      if (!switchWrap.hidden && switchSelect.value === String(data.switch.id)) items.push({id:data.switch.id,quantity:1,properties:addonProperties});
      busy = true;
      error.hidden = true;
      update();
      try {
        const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || data.messages.error);
        window.location.assign(root.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || data.messages.error;
        error.hidden = false;
        busy = false;
        update();
      }
    });
    update();
  }
  document.querySelectorAll('[data-icl-product]').forEach(mount);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-icl-product]').forEach(mount));
})();
